(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product__rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.psw-product-rating .jdgm-preview-badge')) return;
    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reviews.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
  }, true);
  } catch(e) { console.error(e); }
})();

})();
